import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=dcf49faa&lang=pug&"
import script from "./UI.vue?vue&type=script&lang=ts&"
export * from "./UI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UI.vue"
export default component.exports